import { put, takeEvery } from "redux-saga/effects"
import { showToast } from "utils"
import {
  checkEventCalendarCanBeDeletedFailed,
  checkEventCalendarCanBeDeletedSuccess,
  cloneEventCalendarFailed,
  cloneEventCalendarSuccess,
  createEventCalendarFailed,
  createEventCalendarSuccess,
  deleteCalendarEventFailed,
  deleteCalendarEventSuccess,
  deleteEventCalendarFailed,
  deleteEventCalendarSuccess,
  getAllCalendarEventsFailed,
  getAllCalendarEventsSuccess,
  getAllEventsCalendarFailed,
  getAllEventsCalendarSuccess,
  getCalendarEventFailed,
  getCalendarEventSuccess,
  getEventCalendarGroupFailed,
  getEventCalendarGroupSuccess,
  getEventsCalendarFailed,
  getEventsCalendarSuccess,
  hideCloneEventCalendarModal,
  hideDeleteCalendarEventModal,
  hideDeleteEventCalendarModal,
  updateEventCalendarFailed,
  updateEventCalendarSuccess,
} from "./actions"
import {
  CHECK_EVENT_CALENDAR_CAN_BE_DELETED,
  CLONE_EVENT_CALENDAR,
  CREATE_EVENT_CALENDAR,
  DELETE_CALENDAR_EVENT,
  DELETE_EVENT_CALENDAR,
  GET_ALL_CALENDAR_EVENTS,
  GET_ALL_EVENTS_CALENDAR,
  GET_CALENDAR_EVENT,
  GET_EVENTS_CALENDAR,
  GET_EVENT_CALENDAR_GROUP,
  UPDATE_EVENT_CALENDAR,
} from "./actionTypes"
import * as url from "helpers/url_helper"
import { axiosPut, del, get, post } from "helpers/api_helper"

function* getEventsCalendar({ payload: params }) {
  try {
    const response = yield get(url.CALENDAR_URL, { params })
    yield put(getEventsCalendarSuccess(response))
  } catch (error) {
    yield put(getEventsCalendarFailed(error))
    showToast("error", error, "Error")
  }
}

function* getCalendarEvent({ payload: params }) {
  try {
    const response = yield get(url.CALENDAR_EVENT_URL, { params })
    yield put(getCalendarEventSuccess(response))
  } catch (error) {
    yield put(getCalendarEventFailed(error))
    showToast("error", error, "Error")
  }
}

function* getAllEventsCalendar({ payload: params }) {
  try {
    const response = yield get(url.CALENDAR_URL, { params })
    yield put(getAllEventsCalendarSuccess(response))
  } catch (error) {
    yield put(getAllEventsCalendarFailed(error))
    showToast("error", error, "Error")
  }
}

function* getAllCalendarEvents({ payload: params }) {
  try {
    const response = yield get(url.CALENDAR_EVENT_URL, { params })
    yield put(getAllCalendarEventsSuccess(response))
  } catch (error) {
    yield put(getAllCalendarEventsFailed(error))
    showToast("error", error, "Error")
  }
}

function* getEventCalendarGroup({ payload: params }) {
  try {
    const response = yield get(`${url.CALENDAR_URL}/${params?.id}`)
    yield put(getEventCalendarGroupSuccess(response))
  } catch (error) {
    yield put(getEventCalendarGroupFailed(error))
    showToast("error", error, "Error")
  }
}

function* createEventCalendar({ payload: params }) {
  try {
    const response = yield post(url.CALENDAR_URL, params)
    yield put(createEventCalendarSuccess(response))
    showToast("success", "Calendar created!", "Success")
  } catch (error) {
    yield put(createEventCalendarFailed(error))
    showToast("error", error, "Error")
  }
}

function* updateEventCalendar({ payload: params }) {
  try {
    const response = yield axiosPut(`${url.CALENDAR_URL}/${params?.id}`, params)
    yield put(updateEventCalendarSuccess(response))
    showToast("success", "Calendar updated!", "Success")
  } catch (error) {
    yield put(updateEventCalendarFailed(error))
    showToast("error", error, "Error")
  }
}

function* checkEventCalendarCanBeDeleted({ payload: params }) {
  try {
    const response = yield get("/admin/calendar/can-be-deleted", { params })
    yield put(
      checkEventCalendarCanBeDeletedSuccess(response?.can_delete || false)
    )
  } catch (error) {
    yield put(checkEventCalendarCanBeDeletedFailed(error))
    showToast("error", error, "Error")
  }
}

function* deleteEventCalendar({ payload: params }) {
  try {
    const response = yield del(`${url.CALENDAR_URL}/${params?.id}`)
    if (params?.callback) {
      params?.callback()
    }
    yield put(deleteEventCalendarSuccess(response))
    yield put(hideDeleteEventCalendarModal())
    showToast("success", "Calendar deleted!", "Success")
  } catch (error) {
    yield put(deleteEventCalendarFailed(error))
    showToast("error", error, "Error")
    yield put(hideDeleteEventCalendarModal())
  }
}

function* cloneEventCalendar({ payload: params }) {
  try {
    const response = yield post("/admin/calendar/clone", params?.values)
    if (params?.callback) {
      params?.callback()
    }
    yield put(cloneEventCalendarSuccess(response))
    yield put(hideCloneEventCalendarModal())
    showToast("success", "Calendar cloned!", "Success")
  } catch (error) {
    yield put(cloneEventCalendarFailed(error))
    showToast("error", error, "Error")
    yield put(hideCloneEventCalendarModal())
  }
}

function* deleteCalendarEvent({ payload: params }) {
  try {
    const response = yield del(`${url.CALENDAR_EVENT_URL}/${params?.id}`)
    if (params?.callback) {
      params?.callback()
    }
    yield put(deleteCalendarEventSuccess(response))
    showToast("success", "Calendar event deleted!", "Success")
    yield put(hideDeleteCalendarEventModal())
  } catch (error) {
    yield put(deleteCalendarEventFailed(error))
    showToast("error", error, "Error")
    yield put(hideDeleteCalendarEventModal())
  }
}

function* eventsSaga() {
  yield takeEvery(GET_EVENTS_CALENDAR, getEventsCalendar)
  yield takeEvery(GET_CALENDAR_EVENT, getCalendarEvent)
  yield takeEvery(GET_ALL_EVENTS_CALENDAR, getAllEventsCalendar)
  yield takeEvery(GET_ALL_CALENDAR_EVENTS, getAllCalendarEvents)
  yield takeEvery(GET_EVENT_CALENDAR_GROUP, getEventCalendarGroup)
  yield takeEvery(CREATE_EVENT_CALENDAR, createEventCalendar)
  yield takeEvery(UPDATE_EVENT_CALENDAR, updateEventCalendar)
  yield takeEvery(DELETE_EVENT_CALENDAR, deleteEventCalendar)
  yield takeEvery(
    CHECK_EVENT_CALENDAR_CAN_BE_DELETED,
    checkEventCalendarCanBeDeleted
  )
  yield takeEvery(CLONE_EVENT_CALENDAR, cloneEventCalendar)
  yield takeEvery(DELETE_CALENDAR_EVENT, deleteCalendarEvent)
}

export default eventsSaga
